"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRefererUrl = void 0;
var module_util_1 = require("../../utils/module.util");
var index_1 = require("./bff/index");
var index_2 = require("./jericho/index");
var getRefererUrl = function () {
    var _a;
    return typeof window !== 'undefined' && ((_a = window.location) === null || _a === void 0 ? void 0 : _a.href)
        ? window.location.href
        : 'unknown';
};
exports.getRefererUrl = getRefererUrl;
var newRelic = (0, module_util_1.getModules)({
    logError: {
        jerichoFn: index_2.logError_jericho,
        bffFn: index_1.logError_bff,
    },
});
exports.default = newRelic;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/newRelic/index.js
// module id = 468
// module chunks = 11